import { initErrorHandling } from "@/lib/error-handling";
import { initVueApp } from "@/lib/vue-app";
import { logThemeInfo } from "@/lib/theme-info";

// Log theme name, version and environment
logThemeInfo();

// Initialize error handling
initErrorHandling();

// Initialize Vue app
initVueApp();
